import { GetMenuResponseV2 } from "api-types";
import { AxiosInstance } from "axios";

import { UseQueryResult, useQuery } from "react-query";

import { getMenuByMenuUrl } from "../menus-client";

export const useMenuByMenuUrlQuery = (
  client: AxiosInstance,
  urlSlug: string,
  menuId?: string
): UseQueryResult<GetMenuResponseV2 | undefined> => {
  return useQuery<GetMenuResponseV2 | undefined>(
    ["menu-by-url", urlSlug, menuId],
    () => getMenuByMenuUrl(client, urlSlug, menuId)
  );
};
